var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.864,
    height: 27.543,
    viewBox: "0 0 20.864 27.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-58.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M73.095,0H59.082a.654.654,0,0,0-.654.654V26.889a.654.654,0,0,0,.654.654H78.638a.654.654,0,0,0,.654-.654V6.2a.655.655,0,0,0-.172-.448L73.542.172A.725.725,0,0,0,73.095,0Z",
    fill: "#ebf0f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M320.426,6.49h5.233a.344.344,0,0,0-.138-.172l-2.789-2.789L319.978.741A.6.6,0,0,0,319.806.6V5.836A.606.606,0,0,0,320.426,6.49Z",
    transform: "translate(-246.436 -0.569)",
    fill: "#d5d6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M112.091,179.825a1.526,1.526,0,0,1-1.033-.448,1.759,1.759,0,0,1-.482-1.653,1.357,1.357,0,0,1,.585-.861,16.217,16.217,0,0,1,3.512-1.962,37.927,37.927,0,0,0,2.066-4.3,9.831,9.831,0,0,1-1.1-3.2,3.048,3.048,0,0,1,.1-1.377c.344-1.1,1.1-1.136,1.412-1.1.069,0,1.274.172,1.48,1.894a9.305,9.305,0,0,1-.792,3.753,11.953,11.953,0,0,0,2.685,3.167,15.892,15.892,0,0,1,3.89.448,1.464,1.464,0,0,1,.792.482,1.277,1.277,0,0,1,.241,1.343h0a1.43,1.43,0,0,1-.275.482,1.33,1.33,0,0,1-1.687.379,18.318,18.318,0,0,1-3.305-2.169,14.482,14.482,0,0,0-4.751,1c-.585,1.067-1.308,2.238-2.135,3.546a1.451,1.451,0,0,1-.654.551h0C112.4,179.79,112.229,179.825,112.091,179.825Zm1.687-3.477a12.857,12.857,0,0,0-2.031,1.274c-.1.1-.207.207-.207.31a.816.816,0,0,0,.275.757.49.49,0,0,0,.413.1h0a.283.283,0,0,0,.172-.172C112.883,177.828,113.365,177.07,113.778,176.347Zm8.022-1.653a19.267,19.267,0,0,0,2.066,1.239.329.329,0,0,0,.413-.1.952.952,0,0,0,.138-.241c.069-.172.069-.241-.034-.344a.666.666,0,0,0-.31-.172A13.049,13.049,0,0,0,121.8,174.695Zm-4.476-3.064c-.344.792-.757,1.687-1.308,2.72a15.714,15.714,0,0,1,3.03-.62A17.2,17.2,0,0,1,117.324,171.631Zm-.344-5.784c-.138,0-.241.138-.344.448a2.056,2.056,0,0,0-.069.93,8.605,8.605,0,0,0,.585,2,6.868,6.868,0,0,0,.448-2.341c-.1-.93-.585-1.033-.62-1.033Z",
    transform: "translate(-49.118 -155.484)",
    fill: "#e56353"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.38834abfe63e46e4ddd5dd68999714d5.svg";
export { ForwardRef as ReactComponent };